import { render, staticRenderFns } from "./Insured.vue?vue&type=template&id=32484891&"
import script from "./Insured.vue?vue&type=script&lang=js&"
export * from "./Insured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports